"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingExplainedInfo = void 0;
var React = require("react");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../commonFunctions");
var PricingExplainedInfo = exports.PricingExplainedInfo = /** @class */ (function (_super) {
    __extends(PricingExplainedInfo, _super);
    function PricingExplainedInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPremiumCalendar = function (constraintEndDate) {
            var periodEndDate = _this.props.subscription.subscriptionPeriodEndDate ? _this.props.subscription.subscriptionPeriodEndDate : constraintEndDate;
            var month1 = moment(periodEndDate).subtract(3, 'M');
            var month2 = moment(periodEndDate).subtract(2, 'M');
            var month3 = moment(periodEndDate).subtract(1, 'M');
            var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(_this.props.interaction);
            if (moment().isBefore(month2)) {
                return (React.createElement(React.Fragment, null,
                    _this.renderCalendarMonth("pr-3", month1.format('MMMM'), "You already paid", _this.getPaidAmount(month1)),
                    _this.renderCalendarMonth("px-2", month2.format('MMMM'), "You won't pay more than", neverHigherAmount),
                    _this.renderCalendarMonth("pl-3", month3.format('MMMM'), "You won't pay more than", neverHigherAmount)));
            }
            else if (moment().isBefore(month3)) {
                return (React.createElement(React.Fragment, null,
                    _this.renderCalendarMonth("pr-3", month1.format('MMMM'), "You already paid", _this.getPaidAmount(month1)),
                    _this.renderCalendarMonth("px-2", month2.format('MMMM'), "You already paid", _this.getPaidAmount(month2)),
                    _this.renderCalendarMonth("pl-3", month3.format('MMMM'), "You won't pay more than", neverHigherAmount)));
            }
            else {
                return (React.createElement(React.Fragment, null,
                    _this.renderCalendarMonth("pr-3", month1.format('MMMM'), "You already paid", _this.getPaidAmount(month1)),
                    _this.renderCalendarMonth("px-2", month2.format('MMMM'), "You already paid", _this.getPaidAmount(month2)),
                    _this.renderCalendarMonth("pl-3", month3.format('MMMM'), "You already paid", _this.getPaidAmount(month3))));
            }
        };
        _this.renderCalendarMonth = function (className, month, text, premium) { return (React.createElement("div", { className: "col-4 ".concat(className) },
            React.createElement("div", { className: "row no-gutters premium-calendar-holders" },
                React.createElement("div", { className: "col-4 pr-1" },
                    React.createElement("div", { className: "col-4" })),
                React.createElement("div", { className: "col-4" }),
                React.createElement("div", { className: "col-4 pl-1" },
                    React.createElement("div", { className: "col-4" }))),
            React.createElement("div", { className: "bg-white-blue overflow-auto premium-calendar" },
                React.createElement("div", { className: "font-weight-normal text-center fs-14 mt-2 mb-1" }, month),
                React.createElement("div", { className: "bg-white py-1 calendar-body p-1" },
                    React.createElement("div", { className: "text-center fs-14" }, text),
                    React.createElement("div", { className: "text-center text-blue-2 font-weight-light" },
                        React.createElement("span", { className: "fs-24" }, (0, commonFunctions_1.getAmountToDisplay)(premium))))))); };
        _this.getPaidAmount = function (month) {
            var renewalPayments = _this.state.payments.paymentDetailsList
                .filter(function (payment) { return payment.policyVersion[0].summary === "RENEWAL"; })
                .filter(function (payment) { return moment(month).isSame(payment.date, 'M'); });
            if (renewalPayments.length > 0) {
                return renewalPayments[0].amount;
            }
            return _this.props.subscription.lastPaymentAmount;
        };
        _this.state = {};
        return _this;
    }
    PricingExplainedInfo.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPaymentHistory().subscribe(function (payments) {
            _this.setState({ payments: payments });
        });
    };
    PricingExplainedInfo.prototype.render = function () {
        if (this.state.payments && this.props.subscription && this.props.policies) {
            this.includesMotorProduct = services_1.productHelper.includesMotorProduct(this.props.policies);
            this.includesRentersProduct = services_1.productHelper.includesRentersProduct(this.props.policies);
            var constraintEndDate = "";
            if (services_1.productHelper.includesMotorProduct(this.props.policies) && this.props.interaction.vehicles) {
                constraintEndDate = (0, commonFunctions_1.convertDate)(this.props.interaction.vehicles[0].factors.constraintEndDate, "DD MMMM YYYY");
            }
            else if (services_1.productHelper.includesRentersProduct(this.props.policies) && this.props.interaction.realEstates) {
                constraintEndDate = (0, commonFunctions_1.convertDate)(this.props.interaction.realEstates[0].realEstateFactors.constraintEndDate, "DD MMMM YYYY");
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "font-weight-extra-light mb-3", role: "alert" },
                    "Your price could go up or down after first month but we guarantee you won't pay more than ",
                    React.createElement("span", { className: "font-weight-semi-bold" },
                        React.createElement("span", { id: "priceGuaranteeNeverHigher" }, (0, commonFunctions_1.getAmountToDisplay)((0, commonFunctions_1.getNeverHigherPeriodAmount)(this.props.interaction))),
                        " per month until ",
                        React.createElement("span", { id: "priceGuaranteeEndDate" }, constraintEndDate)),
                    " - see below subscription plan for 3 months"),
                React.createElement("div", { className: "mx-auto mb-4 premium-calendar-section" },
                    React.createElement("div", { className: "row no-gutters" }, this.renderPremiumCalendar(constraintEndDate))),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "All figures include Insurance Premium Tax"),
                React.createElement("h4", { className: "font-weight-semi-bold fs-18 text-blue-2" }, "Why can the price change?"),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "Because Flow works on a month-by-month basis, risk factors are reviewed more often than an annual insurance policy. This means your price can change."),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "The good news is we\u2019ll give you a guaranteed maximum price every three months, and you\u2019ll get our best price whether you\u2019re a new or existing Flow customer."),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "Plus, you won\u2019t be paying for any admin or cancellation fees \u2013 just great quality cover."),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "Your guaranteed maximum price could change during this time if you make any changes to your subscription e.g. move address or add extra cover."),
                React.createElement("h4", { className: "font-weight-semi-bold fs-18 text-blue-2" }, "What things affect my price?"),
                React.createElement("ul", { className: "font-weight-extra-light" },
                    React.createElement("li", null, "Your age"),
                    React.createElement("li", null, "Any claims you\u2019ve made"),
                    this.includesMotorProduct && React.createElement(React.Fragment, null,
                        React.createElement("li", null, "Your car getting older"),
                        React.createElement("li", null, "The cost of repairing your vehicle including the parts and labour needed"),
                        React.createElement("li", null, "A change in your car\u2019s grouping driven by its overall claims performance")),
                    this.includesRentersProduct && React.createElement(React.Fragment, null,
                        React.createElement("li", null, "Moving house"),
                        React.createElement("li", null, "Adding extra cover"))),
                React.createElement("h4", { className: "font-weight-semi-bold fs-18 text-blue-2" }, "What happens after the first three months?"),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "We\u2019ll email you seven days before your first three months are up and give you a new guaranteed price. You\u2019ll be able to find it by logging into your account, too."),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "Don't worry \u2013 this price shouldn't change much unless you've made a claim or there's been a major change in your circumstances."),
                React.createElement("h4", { className: "font-weight-semi-bold fs-18 text-blue-2" }, "What happens if I'm not happy with my new price?"),
                React.createElement("p", { className: "font-weight-extra-light mb-4" }, "We hate goodbyes. But if you need to cancel your cover you can do so without paying a cancellation fee. Just log into your account and follow the simple steps to \u2018Cancel my subscription\u2019.")));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], PricingExplainedInfo.prototype, "customerPortalService", void 0);
    return PricingExplainedInfo;
}(React.Component));
//# sourceMappingURL=PricingExplainedInfo.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/PricingExplainedInfo.js
// module id = 1080
// module chunks = 0